module.exports = __webpack_public_path__ + "img/fondo_bg_login.0dccc948.svg";